import * as types from '../types/talentsTypes';

import { enhanceTalentData } from '../../utils/talentUtils';

import { TALENTS_MODE } from '../../config/consts';

const initialState = {
  mode: TALENTS_MODE.filters,
  page: 1,
  size: 24,
  total: 0,
  data: [],
  error: null,
  loading: false,
};

const talentsReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_TALENTS_STATE:
      return initialState;

    case types.FETCH_TALENTS:
      return { ...state, loading: true, mode: TALENTS_MODE.filters };

    case types.SEARCH_TALENTS:
      return { ...state, loading: true, mode: TALENTS_MODE.search };

    case types.FETCH_TALENTS_SUCCESS:
      return {
        ...state,
        data: enhanceTalentData(action.payload.results),
        total: action.payload.longlist_count,
        error: null,
        loading: false,
      };

    case types.SEARCH_TALENTS_SUCCESS:
      return {
        ...state,
        data: enhanceTalentData(action.payload.results),
        total: action.payload.results.length,
        error: null,
        loading: false,
      };

    case types.FETCH_TALENTS_FAILURE:
    case types.SEARCH_TALENTS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case types.SET_TALENTS_PAGE:
      return { ...state, page: action.payload };

    case types.SET_TALENTS_SIZE:
      return { ...state, size: action.payload };

    case types.SET_TALENTS_TOTAL:
      return { ...state, total: action.payload };

    default:
      return state;
  }
};

export default talentsReducers;
